module.exports = __webpack_public_path__ + "static/media/bodiometer_workflow_portrait.ccb00ee3.mp4";